import React from 'react';
import { Outlet } from 'react-router-dom';


export const ProgramsIndex = () => {
    return (
        <div className='flex flex-col flex-1'>
            <Outlet />
        </div>)
}